import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

type TemplateFieldsTableContext = {
  isTableInsideDetailsPanel: boolean
  selectedSubFieldPath: Optional<string>
}

const [useTemplateFieldsTableContext, TemplateFieldsTableContextProvider] =
  createRequiredContext<TemplateFieldsTableContext>('TemplateFieldsTable')

export { TemplateFieldsTableContextProvider, useTemplateFieldsTableContext }
